module.exports = __webpack_public_path__ + "static/media/twich.cb2f9db9.svg";